import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getBlogBySlug, BlogPost as BlogPostModel } from "../services/blogServices";

const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [post, setPost] = useState<BlogPostModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;
    let active = true;
    setLoading(true);
    getBlogBySlug(slug)
      .then((p) => {
        if (active) setPost(p);
      })
      .catch(() => {
        if (active) setError("Couldn't load this post.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [slug]);

  if (loading) return <div className="container py-5"><p className="text-muted">Loading…</p></div>;
  if (error || !post) return <div className="container py-5"><p className="text-danger">{error ?? "Post not found."}</p></div>;

  return (
    <article className="container py-5">
      <h1 className="fw-bold">{post.title}</h1>
      <p className="text-muted">
        By {post.author} · {post.publishDate.toLocaleDateString()}
      </p>
      {post.thumbnailImgSrc && (
        <img
          src={post.thumbnailImgSrc}
          alt={post.thumbnailAltText}
          className="img-fluid rounded my-4"
        />
      )}
      {/* Ghost returns sanitized HTML for the post body. */}
      <div dangerouslySetInnerHTML={{ __html: post.html }} />
    </article>
  );
};

export default BlogPost;
